import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { UserType } from '../../interfaces/userType.enum';

const isUserType = (value: string): value is UserType =>
    (Object.values(UserType) as string[]).includes(value);

/**
 * Returns a function that turns a role (UserType value) into its display label in the current language.
 * The enum value is still what gets submitted; unknown values (legacy roles) are shown as they are.
 */
export const useRoleLabel = () => {
    const { t } = useTranslation('users');
    return useCallback(
        (type?: string | null): string => {
            if (!type) return '';
            return isUserType(type) ? t(`roles.${type}`) : type;
        },
        [t],
    );
};
